module.exports = __webpack_public_path__ + "img/1.679e9677.jpg";